import { render, staticRenderFns } from "./SolicitudManual.vue?vue&type=template&id=0b226151"
import script from "./SolicitudManual.vue?vue&type=script&lang=js"
export * from "./SolicitudManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports